module.exports = __webpack_public_path__ + "img/9791191716030.946f8877.jpg";